module.exports = __webpack_public_path__ + "img/73.3418d711.png";